export default {"src":"/_next/static/image/public/images/language/it.20ddc2b8c86f24a6886ee4066727c3b4.svg","height":20,"width":20};